<template>
  <v-container>
    <div>
      <v-btn class="mb-3" @click="goBack" prepend-icon="mdi-arrow-left" text="Back to List" />
    </div>

    <v-row>
      <v-col cols="12">
        <div class="text-h6 mb-4">Manage Account Instructions</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Description Instructions</span>
            <v-btn color="grey-darken-1" variant="text" size="small" prepend-icon="mdi-plus" @click="openAdd('description')">Add Instruction</v-btn>
          </v-card-title>
          <v-card-text>
            <v-list lines="two" class="mt-3">
              <template v-if="isLoading">
                <div class="text-center py-4">
                  <v-progress-circular indeterminate />
                  <div class="mt-2">Loading instructions...</div>
                </div>
              </template>
              <template v-else-if="descList.length === 0">
                <div class="pa-4 text-medium-emphasis">No description instructions found. Create your first instruction to get started.</div>
              </template>
              <template v-else>
                <v-list-item v-for="item in descList" :key="item.id" :subtitle="truncate(item.content)" class="border rounded mb-2">
                <template #title>
                  <div class="d-flex align-center">
                    <span class="mr-2">{{ item.title }}</span>
                    <v-chip v-if="item.isActive" size="x-small" color="success" label>Active</v-chip>
                  </div>
                </template>
                  <template #append>
                    <v-tooltip text="View">
                      <template #activator="{ props }">
                        <v-btn v-bind="props" icon="mdi-magnify" size="small" variant="text" @click="view(item)"></v-btn>
                      </template>
                    </v-tooltip>
                    <v-menu v-if="!item.isActive || true" location="bottom end">
                      <template #activator="{ props }">
                        <v-btn v-bind="props" icon="mdi-dots-vertical" size="small" variant="text"></v-btn>
                      </template>
                      <v-list density="compact" class="pa-2">
                        <v-list-item v-if="!item.isActive" @click="setActive(item)" class="mb-1" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-check-circle</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Set Active</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="edit(item)" class="mb-1" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-pencil</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="askDelete(item)" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-delete</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Highlight Instructions</span>
            <v-btn color="grey-darken-1" variant="text" size="small" prepend-icon="mdi-plus" @click="openAdd('highlight')">Add Instruction</v-btn>
          </v-card-title>
          <v-card-text>
            <v-list lines="two" class="mt-3">
              <template v-if="isLoading">
                <div class="text-center py-4">
                  <v-progress-circular indeterminate />
                  <div class="mt-2">Loading instructions...</div>
                </div>
              </template>
              <template v-else-if="highList.length === 0">
                <div class="pa-4 text-medium-emphasis">No highlight instructions found. Create your first instruction to get started.</div>
              </template>
              <template v-else>
                <v-list-item v-for="item in highList" :key="item.id" :subtitle="truncate(item.content)" class="border rounded mb-2">
                <template #title>
                  <div class="d-flex align-center">
                    <span class="mr-2">{{ item.title }}</span>
                    <v-chip v-if="item.isActive" size="x-small" color="success" label>Active</v-chip>
                  </div>
                </template>
                  <template #append>
                    <v-tooltip text="View">
                      <template #activator="{ props }">
                        <v-btn v-bind="props" icon="mdi-magnify" size="small" variant="text" @click="view(item)"></v-btn>
                      </template>
                    </v-tooltip>
                    <v-menu v-if="!item.isActive || true" location="bottom end">
                      <template #activator="{ props }">
                        <v-btn v-bind="props" icon="mdi-dots-vertical" size="small" variant="text"></v-btn>
                      </template>
                      <v-list density="compact" class="pa-2">
                        <v-list-item v-if="!item.isActive" @click="setActive(item)" class="mb-1" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-check-circle</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Set Active</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="edit(item)" class="mb-1" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-pencil</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="askDelete(item)" density="compact">
                          <template #prepend>
                            <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-delete</v-icon>
                          </template>
                          <v-list-item-title class="text-body-2 text-medium-emphasis">Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showDialog" max-width="720px">
      <v-card>
        <v-card-title>{{ editing ? 'Edit Instruction' : 'Add Instruction' }}</v-card-title>
        <v-card-text>
          <v-form v-model="isValid" @submit.prevent="save">
            <v-text-field v-model="form.title" label="Title" :rules="[v=>!!v||'Required']" variant="outlined" class="mb-3" />
            <v-textarea v-model="form.content" label="Content" rows="10" variant="outlined" :rules="[v=>!!v||'Required']" />
            <v-checkbox v-model="form.isActive" label="Set as active" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text="Cancel" @click="close()" />
          <v-btn color="primary" text="Save" :disabled="!isValid" :loading="saving" @click="save" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showView" max-width="800px">
      <v-card class="view-card">
        <v-card-title class="d-flex justify-space-between align-center sticky-header">
          <span>{{ viewing?.title }}</span>
          <v-btn size="small" variant="text" icon="mdi-content-copy" @click="copy(viewing)"></v-btn>
        </v-card-title>
        <v-card-text class="scroll-body">
          <v-textarea :model-value="viewing?.content" readonly auto-grow rows="12" variant="outlined" />
        </v-card-text>
        <v-card-actions class="sticky-footer">
          <v-spacer />
          <v-btn text="Close" @click="showView=false" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDelete" max-width="400px">
      <v-card>
        <v-card-title>Delete Instruction</v-card-title>
        <v-card-text>Are you sure you want to delete "{{ deleting?.title }}"?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text="Cancel" @click="showDelete=false" />
          <v-btn color="error" text="Delete" :loading="saving" @click="doDelete" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import { useAccountSettingsStore } from '@/stores/accountSettings'
import { listAccountInstructions, createAccountInstruction, updateAccountInstruction, deleteAccountInstruction } from '@/apis'

interface Props { goBack?: () => void }
const props = withDefaults(defineProps<Props>(), { goBack: undefined })

const account = useAccountSettingsStore()
const descList = ref<any[]>([])
const highList = ref<any[]>([])
const isLoading = ref(false)
const showDialog = ref(false)
const showDelete = ref(false)
const showView = ref(false)
const isValid = ref(false)
const saving = ref(false)
const editing = ref(false)
const form = ref<{ id?: string; type: 'description'|'highlight'; title: string; content: string; isActive: boolean }>({ type:'description', title:'', content:'', isActive:false })
const deleting = ref<any|null>(null)
const viewing = ref<any|null>(null)

const truncate = (s: string, n=120) => {
  const t = String(s||'')
  return t.length>n ? t.slice(0,n)+'…' : t
}

const load = async () => {
  isLoading.value = true
  try {
    const id = String(account.accountId || '').trim()
    if (!id) return
    const [d,h] = await Promise.all([
      listAccountInstructions(id,'description'),
      listAccountInstructions(id,'highlight'),
    ])
    descList.value = d
    highList.value = h
  } catch (e) {
    console.error('Failed to load account instructions', e)
  } finally {
    isLoading.value = false
  }
}

const openAdd = (type:'description'|'highlight') => {
  editing.value = false
  form.value = { type, title:'', content:'', isActive:false }
  showDialog.value = true
}

const edit = (item:any) => {
  editing.value = true
  form.value = { id:item.id, type:item.type, title:item.title, content:item.content, isActive:item.isActive }
  showDialog.value = true
}

const close = () => { showDialog.value=false; editing.value=false }

const save = async () => {
  saving.value = true
  try{
    if(editing.value && form.value.id){
      await updateAccountInstruction(account.accountId, form.value.id, { title: form.value.title, content: form.value.content, isActive: form.value.isActive })
    }else{
      await createAccountInstruction(account.accountId, { title: form.value.title, content: form.value.content, type: form.value.type, isActive: form.value.isActive })
    }
    await load(); close()
  } finally { saving.value=false }
}

const askDelete = (item:any)=>{ deleting.value=item; showDelete.value=true }
const doDelete = async ()=>{ if(!deleting.value) return; saving.value=true; try{ await deleteAccountInstruction(account.accountId, deleting.value.id); await load(); showDelete.value=false; deleting.value=null } finally { saving.value=false } }
const setActive = async (item:any)=>{
  saving.value = true
  isLoading.value = true
  try{
    await updateAccountInstruction(account.accountId, item.id, { isActive:true })
    await load()
  } finally {
    saving.value = false
    isLoading.value = false
  }
}
const view = (item:any)=>{ viewing.value=item; showView.value=true }
const copy = async (item:any)=>{ try{ await navigator.clipboard.writeText(String(item?.content||'')) }catch{} }
const goBack = () => { if (props.goBack) props.goBack() }

watch(() => account.accountId, () => { load() }, { immediate: true })
onMounted(() => { load() })
</script>

<style scoped>
.border { border: 1px solid rgba(0,0,0,0.12); }
.view-card { max-height: 80vh; display: flex; flex-direction: column; }
.scroll-body { overflow-y: auto; overflow-x: hidden; flex: 1 1 auto; }
.sticky-header { position: sticky; top: 0; z-index: 2; background: rgb(var(--v-theme-surface)); }
.sticky-footer { position: sticky; bottom: 0; z-index: 2; background: rgb(var(--v-theme-surface)); }
</style>


